import { cloneElement } from 'react';

import { Polygon } from '../shared';

type Props = {
  highlightedCoordinates: { lat: number; lng: number }[];
  map: google.maps.Map;
};

const SearchMapPolygon: React.FC<Props> = ({ highlightedCoordinates, map }) => {
  if (!highlightedCoordinates.length) {
    return null;
  }

  return (
    <>
      {cloneElement(
        <Polygon
          paths={highlightedCoordinates}
          strokeColor="#EF7048"
          strokeOpacity={1}
          strokeWeight={1}
          fillColor="#EF9981"
          fillOpacity={0.2}
        />,
        { map }
      )}
    </>
  );
};

export default SearchMapPolygon;
